import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createAlarmFailed,
  createAlarmRequested,
  createAlarmSucceeded,
  deleteAlarmFailed,
  deleteAlarmRequested,
  deleteAlarmSucceeded,
  updateAlarmFailed,
  updateAlarmRequested,
  updateAlarmSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createAlarmRequest(deviceId, localId, data) {
  yield put(
    createAlarmRequested(localId, {
      ...data,
      deviceId,
    }),
  );

  try {
    const { item } = yield call(request, api.createAlarm, deviceId, data);

    const action = createAlarmSucceeded(localId, item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createAlarmFailed(localId, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateAlarmRequest(id, data) {
  yield put(updateAlarmRequested(id, data));

  try {
    const { item } = yield call(request, api.updateAlarm, id, data);

    const action = updateAlarmSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateAlarmFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteAlarmRequest(id) {
  yield put(deleteAlarmRequested(id));

  try {
    const { item } = yield call(request, api.deleteAlarm, id);

    const action = deleteAlarmSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteAlarmFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
